import React from "react";
import SubHeader from "../../components/SubHeader/SubHeader";
import GetStartedMainLayout from "../../components/GetStartedMainLayour.js/GetStartedMainLayout";
import GetStartedSideMenu from "../../components/GetStartedSideMenu/GetStartedSideMenu";
import {useMyContext} from "../../context/MyContext";

function GetStarted() {
  const {setEntity} = useMyContext();
  setEntity(null);
  const getStartedMenu=[
    {
      "header": "Get Started",
      "subEntities": [
        {
          "name": "Introduction",
          "tags": [
            {
              "name": "Introduction",
              "id": "Introduction",
            },
          ],
        },
        {
          "name": "Authentication API",
          "tags": [
            {
              "name": "Authentication API",
              "id": "Authentication API",
            },
          ],
        },
        {
          "name": "Getting Started",
          "tags": [
            {
              "name": "Getting Started",
              "id": "Getting Started",
            },
          ],
        },
      ],
    },
  ];
  return (
    <>
      <SubHeader component="GetStarted"/>
      <GetStartedSideMenu menu={getStartedMenu}/>
      <GetStartedMainLayout/>
    </>
  );
}

export default GetStarted;
